import calendarPicto from 'assets/images/membership/picto-calendar.svg';
import cancelPicto from 'assets/images/membership/picto-cancel.svg';
import shippingPicto from 'assets/images/membership/picto-shipping.svg';

export const subscriptionPerksContent = {
  title: {
    haircare: {
      prospect: (
        <>
          Subscribe for
          <b> 60%</b> off your first order <br />— plus <b>15%</b> off every future order
        </>
      ),
      nonSubscriber: (
        <>
          Subscribe for
          <b> 60%</b> off your first order <br />— plus <b>15%</b> off every future order
        </>
      ),
      subscriber: (
        <>
          You’re <b>saving 15%</b> as a haircare subscriber!
        </>
      ),
      churnedSubscriber: (
        <>
          <b>Save 15%</b> when you subscribe to haircare
        </>
      ),
      subscriberToBoth: (
        <>
          You’re <b>saving 15%</b> as a haircare and skincare subscriber!
        </>
      ),
    },
    skincare: {
      prospect: (
        <>
          Subscribe for your
          <b> free Skincare Starter Set</b> <br />— plus <b>15%</b> off every future order.
        </>
      ),
      nonSubscriber: (
        <>
          Subscribe for
          <b> 50%</b> off your first order <br />— plus <b>15%</b> off every future order
        </>
      ),
      subscriber: (
        <>
          You’re <b>saving 15%</b> as a skincare subscriber!
        </>
      ),
      churnedSubscriber: (
        <>
          <b>Save 15%</b> when you subscribe to skincare
        </>
      ),
      subscriberToBoth: (
        <>
          You’re <b>saving 15%</b> as a haircare and skincare subscriber!
        </>
      ),
    },
  },
  content: [
    { logo: cancelPicto, text: 'Cancel any time', alt: '', width: 14, height: 14 },
    { logo: shippingPicto, text: 'Free shipping', alt: '', width: 23, height: 12 },
    {
      logo: calendarPicto,
      text: 'Refills on your schedule',
      alt: '',
      width: 17,
      height: 19,
    },
  ],
};
